export var getTransformFromPlacement = function (placement) {
    var _a = placement.split('-'), first = _a[0], second = _a[1];
    var vertical = first === 'top'
        ? 'bottom'
        : first === 'bottom'
            ? 'top'
            : second === 'end'
                ? 'top'
                : second === 'start'
                    ? 'bottom'
                    : 'center';
    var horizontal = first === 'left'
        ? 'right'
        : first === 'right'
            ? 'left'
            : second === 'end'
                ? 'left'
                : second === 'start'
                    ? 'right'
                    : 'center';
    return {
        vertical: vertical,
        horizontal: horizontal,
    };
};
